import React, { useState, useEffect } from "react";
import { Alert, Button, Container } from "react-bootstrap";

import decodeJwt, {
  JwtPayload,
} from "../../../helpers/jwt-token-access/jwtdecode";
import HomewownerContractStatus from './contractStatus'
import ContractorDashboard from "pages/ContractorDashboard";
import AgentDashboard from "./AgentDashboard";
import { CallAPIGetPromise } from "Common/commaon";
import AdminDashboard from "./AdminDashboard";
import RecommendedPropertiesPreview from "./RecommendedPropertiesPreview";
import ContractorDiscoveryPreview from "./ContractorDiscoveryPreview";

const RealEstate = () => {
  const [decodedJwt, setDecodedJwt] = useState({});
  const [cardWarning, setCardWarning] = useState<any>(null);
  useEffect(() => {
    // Call the decodeJwt function to get the decoded values
    const decodedToken: (JwtPayload & { userId?: number }) | null = decodeJwt();

    if (decodedToken) {
      // Access the decoded values
      setDecodedJwt(decodedToken.userType);
      if (decodedToken.userId) {
        CallAPIGetPromise("/v2/api/billing-alerts/customer-card-warning")
          .then((response: any) => setCardWarning(response?.data || null))
          .catch(() => setCardWarning(null));
      }
    } else {
      console.error("Decoded token is null");
    }
  }, []);
  
  return (
    <React.Fragment>
      <div className={`page-content dashboard-page${decodedJwt === "contractor" ? " contractor-dashboard-page" : ""}`}>
        <Container fluid className="dashboard-content-shell">
          {cardWarning?.show ? (
            <Alert
              variant={cardWarning?.urgent ? "danger" : "warning"}
              className="d-flex align-items-center justify-content-between gap-3"
            >
              <span>
                <strong>{cardWarning?.urgent ? "Payment card action required." : "Payment method expiring soon."}</strong>{" "}
                {cardWarning?.message}
                {cardWarning?.last4 ? ` Card ending ${cardWarning.last4}.` : ""}
                {cardWarning?.expiryDate ? ` Expiry: ${cardWarning.expiryDate}.` : ""}
              </span>
              <Button
                size="sm"
                variant={cardWarning?.urgent ? "danger" : "warning"}
                href="/merchant/payment-setup"
              >
                Update Card
              </Button>
            </Alert>
          ) : null}
    
          {/* {decodedJwt === "homeowner" ? (
            <Row>
              <Property />
              <RevenueOverview />
            </Row>
          ) : (
            ""
          )} */}
          {/* {decodedJwt === "admin" || decodedJwt === "contractor" ? (
            <Row>
              <PropertiesType />
              <RevenueOverview />
            </Row>
          ) : (
            ""
          )} */}
          {decodedJwt === "homeowner" ? (
            <>
              <div className="tailwind-prefix">
                <HomewownerContractStatus />
                {/* <Feedback />
                <AgentList />
                <PropertyCharts />
                <RecentActivity /> */}
              </div>
              <ContractorDiscoveryPreview />
              <RecommendedPropertiesPreview />
            </>
          ) : (
            ""
          )}
          {decodedJwt === "admin" ? (
            <AdminDashboard />
          ) : (
            ""
          )}
          {decodedJwt ==="contractor" ?(
          <>
      <ContractorDashboard/>
          </>)
          :<></>
            
        }
        {decodedJwt === "real_estate_agent" ? <AgentDashboard /> : <></>}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default RealEstate;
